import type { JSX, ReactNode } from 'react'
import { Link } from '#src/components/core/Link.tsx'

export interface ClinicalHoverLayoutProps {
  title: ReactNode
  status: ReactNode
  metadata?: ReactNode
  children?: ReactNode
  noteBlock?: ReactNode
  to?: string
}

export function ClinicalHoverLayout({
  title,
  status,
  metadata,
  children,
  noteBlock,
  to,
}: ClinicalHoverLayoutProps): JSX.Element {
  const topContent = (
    <>
      <div className="[&_h3]:line-clamp-2">{title}</div>
      <div className="mt-1.5 flex items-center gap-2">
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
          {metadata}
        </div>
        <div className="shrink-0">{status}</div>
      </div>
      {children && <div className="mt-2">{children}</div>}
    </>
  )

  return (
    <div className="flex max-w-[360px] flex-col gap-0 px-0.5 py-1">
      {to ? (
        <Link
          to={to}
          className="-mx-1.5 -my-0.5 flex flex-col gap-0 rounded-md px-1.5 py-0.5 text-inherit no-underline transition-colors hover:bg-muted/50"
        >
          {topContent}
        </Link>
      ) : (
        topContent
      )}
      {noteBlock}
    </div>
  )
}
